import userStorage from "../services/userStorage";

const store = {
    state: {
        jwt: undefined,
        user: undefined,
        profile: undefined
    },
    getters: {
        hasToken: state => {
            return !!state.jwt;
        },
        token: state => {
            return state.jwt;
        },
        user: state => {
            return { ...state.user };
        },
        profile: state => {
            return state.profile;
        }
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
        },
        setToken(state, token) {
            state.jwt = token;
        },
        setProfile(state, profile) {
            state.profile = profile;
        }
    },
    actions: {
        initStore(context) {
            const obj = userStorage.fetchData();
            if (obj.user) {
                context.dispatch("setUser", obj.user);
            }
            if (obj.token) {
                context.dispatch("setToken", obj.token);
            }
            if (obj.profile) {
                context.dispatch("setProfile", obj.profile);
            }
        },
        setUser(context, user) {
            context.commit("setUser", user);
            userStorage.setUser(user);
        },
        setToken(context, token) {
            context.commit("setToken", token);
            userStorage.setToken(token);
        },
        setProfile(context, profile) {
            context.commit("setProfile", profile);
            userStorage.setProfile(profile);
        },
        hasToken(context) {
            return context.state.jwt !== undefined;
        },
        isAdmin(context) {
            return (
                context.state.user !== undefined && context.state.user.is_admin
            );
        },
        isOnline(context) {
            return (
                context.state.user !== undefined && context.state.user.online
            );
        },
        clearUserState() {
            this.dispatch("setUser", undefined);
            this.dispatch("setToken", undefined);
            this.dispatch("setProfile", undefined);
            userStorage.clearData();
        }
    }
};

export default store;
